var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPetmoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_568_1954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 26,
    width: 54,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.9999 26H22.9999V73.8595H76.9999V26Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_568_1954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.017 38.8212C66.9283 30.8445 59.1861 25.9566 49.7993 26.0003C40.4125 25.9566 32.6703 30.8445 28.5816 38.8212C28.154 39.7556 28.3373 40.2314 29.2716 40.6627C32.947 42.7402 32.3083 41.9235 34.5623 38.9065C38.1494 33.6671 43.9627 31.2163 49.8001 31.2759C55.6374 31.2163 61.4499 33.6663 65.0378 38.9065C67.2918 41.9235 66.6538 42.7402 70.3285 40.6627C71.2621 40.2306 71.4461 39.7548 71.0185 38.8212H71.017Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4676 49.3384C75.0302 47.9275 74.6977 47.7805 73.2936 48.2269C72.5802 48.4539 71.8616 48.6771 71.204 49.0428C70.416 49.4809 70.2358 49.907 70.502 50.7629C70.9899 52.3329 71.4838 53.8954 71.7711 55.5227C72.7521 60.9672 70.3255 67.5518 63.8736 68.8104C61.3489 69.3028 56.6728 67.4621 54.0388 64.9171C53.8359 64.721 53.8118 64.4065 53.9754 64.1773C61.0209 54.3184 58.653 48.0421 54.1647 45.5914C51.5805 44.1805 48.4193 44.1805 45.8343 45.5914C41.346 48.0421 38.9782 54.3184 46.0236 64.1773C46.1873 64.4065 46.1631 64.7217 45.9603 64.9171C43.3263 67.4621 38.6502 69.3028 36.1255 68.8104C29.6736 67.5511 27.2469 60.9672 28.228 55.5227C28.5153 53.8954 29.01 52.3321 29.4971 50.7629C29.7633 49.907 29.5831 49.4817 28.7951 49.0428C28.1367 48.6771 27.4188 48.4531 26.7055 48.2269C25.3006 47.7805 24.9688 47.9275 24.5315 49.3384C18.0961 68.315 32.9885 81.5876 49.5475 68.7983C49.6975 68.6649 49.8483 68.597 49.9992 68.5774C50.15 68.597 50.3008 68.6649 50.4508 68.7983C67.0098 81.5876 81.9022 68.315 75.4669 49.3384H75.4676Z",
    fill: "#424242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPetmoa);
export default __webpack_public_path__ + "static/media/logo_petmoa.735eb0a933a913422621e6c7afaecca1.svg";
export { ForwardRef as ReactComponent };